import { Select } from '@iqueue/ui-kit'
import HelpersPresenter from '../../api/helpersPresenter'
import { useCallback } from 'react'
import { t } from '../../hooks/useTranslate'

export default function PickNodeStatus({
  name = 'status',
  value,
  ...props
}) {
  const render = useCallback((key) => {
    return {
      id: key,
      title: t(`status.node.${ key }`),
    }
  }, [])

  return <Select
    name={ name }
    entries={ HelpersPresenter.nodesStatuses }
    render={ render }
    value={ value }
    { ...props }
  />
}
